import React from 'react'

const Chat = () => {
  return (
   <div className='container py-10'>
     <div className='p-5 bg-white max-h-lg w-full rounded-md'>
        <div className="relative flex h-screen">
      {/* Chat List */}
      <div className="w-1/4 bg-gray-200 p-4">
        <h2 className="text-xl font-bold mb-4">Chats</h2>
        <ul className='space-y-3'>
          {/* Sample chat list items with avatars */}
          <li className="flex items-center p-2  bg-white rounded-md shadow-md">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <span>User 1</span>
          </li>
          <li className="flex items-center p-2  bg-white rounded-md shadow-md">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <span>User 1</span>
          </li>
          <li className="flex items-center p-2  bg-white rounded-md shadow-md">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <span>User 1</span>
          </li>
        </ul>
      </div>

      {/* Open Chat */}
      <div className="w-3/4 bg-gray-100 p-4 relative">
        <div className='w-full p-2 rounded-md shadow-lg bg-white mb-3'>
        <h2 className="text-xl font-bold mb-4">User Name</h2>
        </div>
        <div className="overflow-y-auto max-h-full">
          {/* Sample chat messages with avatars */}
          <div className="flex items-start mb-4">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <div>
              <strong>User 1:</strong> Hello there!
            </div>
          </div>
          <div className="flex items-start mb-4">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <div>
              <strong>User 2:</strong> Hi! How can I help you?
            </div>
          </div>
          <div className="flex items-start mb-4">
            <div className="w-8 h-8 bg-gray-400 rounded-full mr-2"></div>
            <div>
              <strong>User 1:</strong> I have a question about your services.
            </div>
          </div>
          {/* Add more chat messages here */}
        </div>
        {/* Chat input field at the bottom */}
        <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-white shadow-lg p-3">
          <div className="flex items-center">
            <input
              type="text"
              className="flex-grow p-2 border border-gray-400 rounded-md outline-none"
              placeholder="Type your message..."
            />
            <button className="bg-primary-yellow-500 text-white p-2 rounded-md ml-2">Send</button>
          </div>
        </div>
      </div>
    </div>


        </div>
   </div>
  )
}

export default Chat